<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M22.3611 0H9.63892C4.31549 0 0 4.31549 0 9.63892V22.3611C0 27.6845 4.31549 32 9.63892 32H22.3611C27.6845 32 32 27.6845 32 22.3611V9.63892C32 4.31549 27.6845 0 22.3611 0Z"
    fill="#ECE0F5"
  />
  <path
    d="M11.2432 14.7246C12.1473 14.7246 13.0144 15.0838 13.6537 15.7231C14.293 16.3624 14.6522 17.2295 14.6522 18.1336V22.5906C14.6522 23.0365 14.5644 23.4781 14.3937 23.8902C14.223 24.3022 13.9729 24.6766 13.6575 24.9919C13.3422 25.3073 12.9678 25.5574 12.5558 25.7281C12.1437 25.8988 11.7021 25.9866 11.2562 25.9866H7.8313V18.1322C7.83149 17.6844 7.9199 17.241 8.09148 16.8274C8.26307 16.4138 8.51446 16.038 8.8313 15.7216C9.14815 15.4051 9.52423 15.1542 9.93807 14.9831C10.3519 14.8121 10.7954 14.7242 11.2432 14.7246Z"
    fill="#5A1CB7"
  />
  <path
    d="M7.827 9.52654C7.827 11.4093 9.35326 12.9355 11.236 12.9355C13.1188 12.9355 14.645 11.4093 14.645 9.52654C14.645 7.6438 13.1188 6.11753 11.236 6.11753C9.35326 6.11753 7.827 7.6438 7.827 9.52654Z"
    fill="#E23393"
  />
  <path
    d="M24.0952 25.9844H20.6732C19.7725 25.9844 18.9088 25.6266 18.2719 24.9897C17.635 24.3528 17.2772 23.489 17.2772 22.5883V18.1314C17.2772 17.2273 17.6364 16.3602 18.2757 15.7209C18.915 15.0816 19.7821 14.7224 20.6862 14.7224C21.5903 14.7224 22.4574 15.0816 23.0967 15.7209C23.7361 16.3602 24.0952 17.2273 24.0952 18.1314V25.9844Z"
    fill="#5A1CB7"
  />
  <path
    d="M24.101 9.5262C24.101 7.64345 22.5747 6.11719 20.692 6.11719C18.8092 6.11719 17.283 7.64345 17.283 9.5262C17.283 11.4089 18.8092 12.9352 20.692 12.9352C22.5747 12.9352 24.101 11.4089 24.101 9.5262Z"
    fill="#5A1CB7"
  />
</svg>
